import {useCallback} from 'react';
import {FlowName, useOnboardingStore} from './OnboardingStore';
import {Step, STEPS} from './onboardingSteps';
import {useUserData} from '@/hooks/useUserData';

const withOnboardingType = (
  details: Record<string, any>,
  flowName: FlowName
) => {
  return {
    ...details,
    OnboardingType: flowName,
  };
};

export default function useScreenPresentationDetails() {
  const {connectedPlatforms} = useUserData({});

  return useCallback(
    (stepForAnalytics: Step) => {
      const state = useOnboardingStore.getState();

      const getStepDetails = (step: Step) => {
        switch (step) {
          case STEPS.NAME_AND_BIRTHDATE:
            return {
              firstName: state.firstName,
              lastName: state.lastName,
              birthDate: state.birthdate,
            };
          case STEPS.CREATOR_SEGMENT:
            return {
              segment: state.segment,
            };
          case STEPS.LOCATION:
            return {
              location: state.location,
            };
          case STEPS.GENDER:
            return {
              gender: state.gender,
            };
          case STEPS.COLLABORATION_RATE:
            return {
              minCollaborationRate: state.minCollaborationRate,
            };
          case STEPS.SPECIALTIES:
            return {
              specialties: Array.from(state.specialties),
            };
          case STEPS.CAPABILITIES:
            return {
              capabilities: Array.from(state.capabilities),
            };
          case STEPS.PORTFOLIO:
            return {
              profilePictureAvailable: !!state.profilePictureUrl,
              portfolioMediaItemsCount: state.portfolioMediaItems.length,
            };
          case STEPS.BIO:
            return {
              bio: state.bio,
            };
          case STEPS.SYNC_PLATFORMS:
            return {
              connectedPlatforms,
            };
          case STEPS.COMPLETION:
          case STEPS.REONBOARDING:
          default:
            return {};
        }
      };

      return withOnboardingType(
        getStepDetails(stepForAnalytics),
        state.flowName
      );
    },
    [connectedPlatforms]
  );
}
